module.exports = __webpack_public_path__ + "img/dice-2.a0be1391.svg";